import { heroMeta, heroTags } from '@/mocks/russianMom';

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20cinematic%20painting%20of%20a%20snowy%20northern%20town%20at%20dusk%20with%20warm%20amber%20window%20light%2C%20a%20lone%20figure%20walking%20with%20a%20small%20suitcase%2C%20muted%20red%20and%20cream%20palette%2C%20soft%20film%20grain%2C%20moody%20atmospheric%20editorial%20illustration&width=1920&height=1080&seq=rusmom-hero-01&orientation=landscape"
          alt=""
          className="h-full w-full object-top object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/70 to-foreground-950/40"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-foreground-950/40"></div>
      </div>

      <div className="relative mx-auto flex max-w-[1280px] flex-col gap-10 px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[1.4fr_1fr]">
          <div className="animate-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1 text-xs text-background-100 backdrop-blur">
              <i className="ri-movie-2-line text-accent-300" aria-hidden="true"></i>
              中文字幕 · 完整版收录
            </span>

            <h1 className="mt-5 font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl">
              俄罗斯妈妈
            </h1>
            <p className="mt-3 max-w-2xl font-heading text-lg text-accent-200 md:text-2xl">
              跨越语言与国界的一场团聚，厨房与餐桌之间的温柔和解
            </p>
            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
              本页提供《俄罗斯妈妈》在线观看的完整信息入口，收录两季共 20 集的高清视频资源，全部配备中文字幕，
              可免费浏览与查找。无论你想从第一季补起，还是直接回看第二季大结局，都能在这里快速定位到对应的剧集。
            </p>

            <div className="mt-7 flex flex-wrap items-center gap-3">
              <a
                href="#episodes"
                className="flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-play-circle-fill text-lg" aria-hidden="true"></i>
                查看全部剧集
              </a>
              <a
                href="#synopsis"
                className="flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
              >
                <i className="ri-book-open-line text-lg" aria-hidden="true"></i>
                阅读剧情简介
              </a>
            </div>

            <div className="mt-8 flex flex-wrap gap-2">
              {heroTags.map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-background-50/20 bg-background-50/5 px-3 py-1 text-xs text-background-200"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="animate-fade-up">
            <div className="mx-auto w-full max-w-[320px] overflow-hidden rounded-lg border border-background-50/15 bg-background-50/5 backdrop-blur">
              <div className="relative h-[420px] w-full md:h-[480px]">
                <img
                  src="https://readdy.ai/api/search-image?query=stylized%20minimal%20movie%20poster%20illustration%20of%20an%20elderly%20woman%20in%20a%20warm%20scarf%20holding%20a%20suitcase%20against%20a%20snowy%20warm%20toned%20background%2C%20muted%20red%20and%20cream%20palette%2C%20soft%20film%20grain%2C%20no%20text%2C%20editorial%20illustration&width=800&height=1200&seq=rusmom-poster-01&orientation=portrait"
                  alt="《俄罗斯妈妈》剧集海报"
                  className="h-full w-full object-top object-cover"
                />
              </div>
              <div className="border-t border-background-50/15 p-4">
                <div className="flex items-center justify-between">
                  <span className="text-xs text-background-300">综合评分</span>
                  <span className="flex items-center gap-1 font-heading text-2xl font-bold text-accent-300">
                    8.7
                    <span className="text-xs font-normal text-background-300">/ 10</span>
                  </span>
                </div>
                <div className="mt-3 flex items-center gap-1">
                  {[0, 1, 2, 3, 4].map((i) => (
                    <i key={i} className="ri-star-fill text-sm text-accent-400" aria-hidden="true"></i>
                  ))}
                  <span className="ml-1 text-xs text-background-300">来自 1,842 条观众短评</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <dl className="grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-50/15 bg-background-50/5 backdrop-blur sm:grid-cols-3 lg:grid-cols-5">
          {heroMeta.map((item) => (
            <div key={item.label} className="border-background-50/10 p-4 sm:border-r">
              <dt className="text-xs text-background-300">{item.label}</dt>
              <dd className="mt-1 text-sm font-medium text-background-50">{item.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}